'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';

import { Button } from '@kit/ui/button';
import { Trans } from '@kit/ui/trans';

import pathsConfig from '~/config/paths.config';

/**
 * Appends `?next=<returnPath>` to an auth URL so the user
 * is redirected back to their current page after sign-in/sign-up.
 */
export function buildAuthUrl(base: string, returnPath: string | null) {
  if (!returnPath || returnPath === '/' || returnPath.startsWith('/auth/'))
    return base;
  return `${base}?next=${encodeURIComponent(returnPath)}`;
}

/**
 * Shared auth buttons for unauthenticated users.
 * Used in both the public home page (floating) and marketing pages (in header).
 */
export function AuthButtons() {
  const pathname = usePathname();

  return (
    <div className="flex items-center gap-2">
      <Button asChild variant="ghost" size="sm">
        <Link href={buildAuthUrl(pathsConfig.auth.signIn, pathname)}>
          <Trans i18nKey="auth:signIn" />
        </Link>
      </Button>

      <Button asChild size="sm">
        <Link href={buildAuthUrl(pathsConfig.auth.signUp, pathname)}>
          <Trans i18nKey="auth:signUp" />
        </Link>
      </Button>
    </div>
  );
}
